import script from "./TabComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./TabComponent.vue?vue&type=script&setup=true&lang=js"

import "./TabComponent.vue?vue&type=style&index=0&id=76cd0d68&lang=scss&scoped=true"
script.__scopeId = "data-v-76cd0d68"

export default script